<e-guided-tour-2></e-guided-tour-2>
<ngx-spinner
  [fullScreen]="true"
  bdColor="rgba(0, 0, 0, 0.4)"
  color="#fff"
  size="medium"
  type="ball-clip-rotate">
</ngx-spinner>

<router-outlet></router-outlet>

<e-popup (isActiveChange)="reload()" *ngIf="adblockPopupShouldExist" [(isActive)]="isAdblockPopupActive">
  <e-popup-title>
    {{ 'app.adblock.title' | translate }}
  </e-popup-title>
  <e-popup-text>
    {{ 'app.adblock.text' | translate }}
  </e-popup-text>
  <e-popup-buttons>
    <e-buttons [align]="'left'">
      <e-button (eButtonClick)="reload()" size="small" type="tertiary">
        {{ 'app.adblock.done' | translate }}
      </e-button>
    </e-buttons>
  </e-popup-buttons>
</e-popup>
